export const DOCUMENTS_QUERY_KEY = 'documents';
export const DOCUMENT_QUERY_KEY = 'document';

export const DOCUMENTS_PAGE_SIZE = 24;

/** Characters before global search looks for Library Documents. */
export const DOCUMENT_SEARCH_MIN_QUERY_LENGTH = 3;

export const DOCUMENTS_STALE_TIME = 30000; // 30 seconds
export const DOCUMENTS_GC_TIME = 5 * 60 * 1000; // 5 minutes

export const DOCUMENTS_QUERY_OPTIONS = {
  staleTime: DOCUMENTS_STALE_TIME,
  gcTime: DOCUMENTS_GC_TIME,
};
